import { gridClasses } from '@mui/x-data-grid';

/** Root attribute present while the grid is scrolled off its left origin;
 *  drives the pinned-column shadow. */
export const SCROLLED_X_ATTR = 'data-scrolled-x';

/**
 * Gradient shadow past the right edge of the pinned-left columns while scrolled.
 */
const pinnedLeftScrollShadow = {
  overflow: 'visible',
  '&::after': {
    content: '""',
    position: 'absolute',
    top: 0,
    right: '-8px',
    width: '8px',
    height: '100%',
    background: 'linear-gradient(to right, rgba(0, 0, 0, 0.1), transparent)',
    pointerEvents: 'none',
  },
};

const style = {
  default: {
    [`.${gridClasses.columnHeader}:first-of-type, .${gridClasses.cell}:first-of-type`]:
      {
        paddingLeft: { xs: '12px', sm: '24px' },
      },
    [`&[${SCROLLED_X_ATTR}] .${gridClasses['cell--pinnedLeft']}, &[${SCROLLED_X_ATTR}] .${gridClasses['columnHeader--pinnedLeft']}`]:
      pinnedLeftScrollShadow,
  },
  noRowsMessage: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    height: '100%',
  },
};

export default style;
